import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import TableServerSideProvider from '~COMPONENTS/tableServerSide/TableServerSideContext';
import ProductContractGroups from './ProductContractGroups';
import ProductContractGroupsEdit from './ProductContractGroupsEdit';

import { columnSortModifiersProductContractGroups, columnFilterModifiersProductContractGroups } from './columns';

export const ContractGroupRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <TableServerSideProvider
          tableId='productContractGroups'
          columnSortModifiers={columnSortModifiersProductContractGroups}
          columnFilterModifiers={columnFilterModifiersProductContractGroups}
        >
          <ProductContractGroups />
        </TableServerSideProvider>
      </Route>
      <Route
        path={`${path}/edit/:productContractGroupId`}
        render={routerProps => <ProductContractGroupsEdit {...routerProps} />}
      />
    </Switch>
  );
};

export default ContractGroupRoutes;
